namespace TabAurous.OMS {
    export interface UserRoleListResponse extends Serenity.ListResponse<number> {
    }
}
